function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpwindDark = function SvgUpwindDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 116 178"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upwind-dark_svg__a",
    x1: 0.465,
    x2: 115.535,
    y1: -1.611,
    y2: 31.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f2583c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    style: {
      stopColor: "#9214c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1e71ed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h116v30H0z",
    style: {
      fill: "url(#upwind-dark_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 178c-31.981 0-58-26.019-58-58V52h32v70c0 14.337 11.663 26 26 26s26-11.663 26-26V52h32v68c0 31.981-26.019 58-58 58",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgUpwindDark;